import { isMobile } from "react-device-detect";

import { Separator } from "@/components/ui/separator/separator";
import { HomeAnnouncementCard } from "./_layout-comps/home-cards/announcement-card";
import { HandbookRender } from "./_layout-comps/handbook-render";
import { HomeMyLeadsCard } from "./_layout-comps/home-cards/my-leads-card";
import { HomeTodosCard } from "./_layout-comps/home-cards/todos-card";
import { HomeAttendanceCard } from "./_layout-comps/home-cards/attendance-card";
import { HomePerformanceReportCard } from "./_layout-comps/home-cards/performance-report-card";
import { LateBanner } from "./_layout-comps/home-cards/late-banner";
import { UpcomingHolidayCard } from "./_layout-comps/home-cards/upcoming-holiday-card";
import { TodayCard } from "./_layout-comps/home-cards/today-card";

const EmployeeHomePage = () => {
  if (isMobile) {
    return (
      <div className="p-5 h-[calc(100vh-56px)]">
        {/* Late Entry Banner - Shows if first check-in was after 9:15 AM */}
        <LateBanner />
        {/* Upcoming Holiday Card - Shows holidays within 7 days */}
        <UpcomingHolidayCard />
        {/* Today: check-in time, break status and today's breaks */}
        <TodayCard />
        <div className="flex items-center justify-center mt-4">
          <h1>Employee Home for Mobile</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="p-5 h-[calc(100vh-56px)] ">
      {/* Late Entry Banner - Shows if first check-in was after 9:15 AM */}
      <LateBanner />

      {/* Upcoming Holiday Card - Shows holidays within 7 days */}
      <UpcomingHolidayCard />

      {/* Today: check-in time, break status and today's breaks */}
      <TodayCard />

      <div className="flex flex-wrap justify-start gap-6 mt-4">
        <HandbookRender />
      </div>

      <Separator className="my-4" />

      <div className="flex flex-wrap gap-6">
        <HomeAnnouncementCard />

        <HomeMyLeadsCard />

        <HomeTodosCard />

        <HomeAttendanceCard />

        <HomePerformanceReportCard />
      </div>
    </div>
  );
};

export default EmployeeHomePage;
